/* -----------------UI--------------- */
import type { Distribution } from "@memorang/types/src/content";

import { getQuickActionsChips } from "@features/dashboard/helpers/common";
import { useExamContext } from "@features/exam/contexts/ExamContext";
import Box from "@memorang/ui/src/components/Box";
import DonutChart from "@memorang/ui/src/components/DonutChart";
import { QuickActionChips } from "components/QuickActionChips";
import type { QuickActionsChipType } from "components/QuickActionChips/types";
import ProductIcon from "../ProductIcon";
/* -----------------Components--------------- */
import RowStats, { type Stat } from "../RowStats";

/* -----------------Props--------------- */
type Props = {
	distribution: Distribution;
	title: string;
	image?: string;
	stats?: Stat[];
	handleQuickActionPress: (action: QuickActionsChipType["type"]) => void;
};

/* -----------------Component--------------- */
const ContentHero = (props: Props) => {
	const { distribution, stats, image, handleQuickActionPress } = props;

	const {
		currentExamContext: { studyPackCollectionId },
	} = useExamContext();

	const HeroOverallProgressDonutChart = () => {
		return (
			<>
				{image && (
					<DonutChart distribution={distribution} radius={64} innerRadius={50}>
						<ProductIcon image={image} size={64} />
					</DonutChart>
				)}
			</>
		);
	};

	const showStats = stats?.length;

	const Stats = () => <RowStats stats={stats || []} />;

	const actionChips = getQuickActionsChips(studyPackCollectionId);

	return (
		<>
			<Box padding={16} gap={16}>
				<HeroOverallProgressDonutChart />
				{showStats ? <Stats /> : null}
			</Box>
			<Box paddingBottom={8}>
				<QuickActionChips
					quickActionsChips={actionChips}
					handleQuickActionPress={handleQuickActionPress}
				/>
			</Box>
		</>
	);
};

export default ContentHero;
